import { j as e, a as n, F as j } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { useState as a, useLayoutEffect as W, useEffect as k } from "react";
import { IonBackdrop as U } from "@ionic/react";
import { translate as h } from "../../string-table.js";
import { Colors as y } from "../../1-foundations/Colors/Colors.js";
import { I as V, g as M } from "../../../Icon-CwNA7zVF.js";
import { z as Y, l as z, q, w as H } from "../../../FeatureFlagProvider-DcQ1RcjV.js";
import "../../../react-paginate-Lh5zQzpz.js";
import { LoadingInterstitial as J } from "../LoadingInterstitial/LoadingInterstitial.js";
import "../../contexts/DesignSystemProvider/DesignSystemProvider.js";
import { LogInButton as _ } from "./LoginButton/LoginButton.js";
function lt(o) {
  const {
    apiError: i,
    app: l,
    build: x,
    buildProfile: f,
    history: p,
    isWeb: O,
    loginWithPasswordPath: R,
    signUpPath: A,
    onLoginEmailSubmit: G,
    platform: g,
    version: S
  } = o, {
    signIn: E,
    isAuthenticating: C
  } = Y(), [w, c] = a(""), [N, r] = a(), [L, d] = a(!1), [b, I] = a(i), T = window.location.search;
  W(() => {
    I(i);
  }, [i]);
  const B = (t) => {
    c(t), Q(t) ? d(!0) : d(!1);
  }, v = async (t) => {
    const {
      provider: m,
      shouldSignUp: P
    } = await G(t).catch((u) => {
      p.push({
        pathname: "/"
      }), r(u);
    });
    if (m)
      switch (m) {
        case "COGNITO":
          r(void 0), p.push({
            pathname: P ? A : R,
            // Explicitly not using `useLocation` as we want to live value vs
            // cached value.
            search: window.location.search,
            state: {
              email: t
            }
          });
          break;
        case "GOOGLE":
          r(void 0), E({
            provider: m.toLowerCase()
          }).catch((u) => {
            r(u);
          });
          break;
      }
  };
  k(() => {
    const t = new URLSearchParams(T).get("email");
    t && (d(!0), c(t), v(t));
  }, []);
  async function D(t) {
    t.preventDefault(), I(void 0), await v(w);
  }
  async function F(t) {
    t.preventDefault(), r(void 0), c(""), await E({
      provider: "google"
    });
  }
  return /* @__PURE__ */ e(H, {
    app: l,
    build: x,
    isWeb: O,
    version: S,
    children: C ? /* @__PURE__ */ n("div", {
      children: [/* @__PURE__ */ e(U, {
        visible: !0
      }), /* @__PURE__ */ e("div", {
        css: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 11,
          background: "var(--swing-white200)",
          width: "100%",
          height: "100%",
          borderRadius: 8,
          maxWidth: 360,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: /* @__PURE__ */ e(J, {})
      })]
    }) : /* @__PURE__ */ n(j, {
      children: [/* @__PURE__ */ n("form", {
        css: {
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 32
        },
        onSubmit: async (t) => await D(t),
        children: [/* @__PURE__ */ e(z, {
          app: l,
          buildProfile: f,
          email: w,
          error: N,
          onEmailInput: (t) => B(t),
          platform: g,
          provider: "cognito",
          readOnly: !1
        }), /* @__PURE__ */ e(_, {
          disabled: !L,
          isFluid: !0,
          hasShadow: !0,
          children: /* @__PURE__ */ n("div", {
            css: s.buttonContentContainer,
            children: [/* @__PURE__ */ e("span", {
              css: {
                ...s.buttonText,
                marginRight: 8
              },
              children: h("LOGIN_EMAIL_ENTRY_LOGIN_LABEL_ENTER_PASSWORD")
            }), /* @__PURE__ */ e(V, {
              name: "Arrow Right",
              color: L ? y.white200 : y.slate400
            })]
          })
        })]
      }), /* @__PURE__ */ e(K, {
        label: h("LOGIN_EMAIL_ENTRY_LABEL_OR")
      }), /* @__PURE__ */ n("form", {
        css: {
          width: "100%"
        },
        onSubmit: async (t) => await F(t),
        children: [/* @__PURE__ */ e(_, {
          variant: "outlined",
          isFluid: !0,
          children: /* @__PURE__ */ n("div", {
            css: s.buttonContentContainer,
            children: [/* @__PURE__ */ e("img", {
              src: M,
              alt: "Login with Google"
            }), /* @__PURE__ */ e("span", {
              css: {
                ...s.buttonText,
                marginLeft: "auto",
                marginRight: "auto"
              },
              children: h("LOGIN_EMAIL_ENTRY_LOGIN_LABEL_CONTINUE_WITH_GOOGLE")
            })]
          })
        }), b && /* @__PURE__ */ e(q, {
          app: l,
          buildProfile: f,
          error: b,
          platform: g
        })]
      })]
    })
  });
}
function K(o) {
  const {
    label: i
  } = o;
  return /* @__PURE__ */ e("div", {
    css: {
      display: "flex",
      alignItems: "center",
      textAlign: "center",
      width: "100%",
      "&::before, &::after": {
        content: '""',
        flex: 1,
        borderBottom: "1px solid var(--swing-gray-200)"
      },
      "&:not(:empty)::before": {
        marginRight: 12
      },
      "&:not(:empty)::after": {
        marginLeft: 12
      }
    },
    children: i
  });
}
function Q(o) {
  return new RegExp(/.+@.+\..{2,}/).test(o);
}
const s = {
  buttonContentContainer: {
    display: "flex",
    flexDirection: "row",
    placeItems: "center",
    justifyContent: "center"
  },
  buttonText: {
    fontFamily: "var(--swing-font-family-headers)"
  }
};
export {
  lt as Login,
  Q as isValidEmail
};
